var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","appear":""},on:{"before-leave":_vm.beforeLeave}},[_c('div',{staticClass:"modal-page center"},[_c('transition',{attrs:{"name":"scale","appear":""}},[_c('section',{ref:"el",staticClass:"modal-window"},[_c('FocusLoop',[_vm._t("default")],2)],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }